export default __webpack_public_path__ + "/images/beach-ball.jpg";